/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nfp_Seo_DescInputs */

const en_nfp_seo_desc = /** @type {(inputs: Nfp_Seo_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Launch a verified, tax-compliant storefront and private community hub for your Church, Charity, or NFP. Zero coding required.`)
};

const es_nfp_seo_desc = /** @type {(inputs: Nfp_Seo_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lanza una tienda verificada que cumpla con la normativa fiscal para tu ONG o iglesia.`)
};

const fr_nfp_seo_desc = /** @type {(inputs: Nfp_Seo_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lancez une vitrine vérifiée, conforme sur le plan fiscal et un hub communautaire privé pour votre église, association caritative ou OBNL. Aucun codage requis.`)
};

const de_nfp_seo_desc = /** @type {(inputs: Nfp_Seo_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starte eine verifizierte, steuerkonforme Storefront und einen privaten Community-Hub für deine Kirche, Wohltätigkeitsorganisation oder NGO.`)
};

const id_nfp_seo_desc = /** @type {(inputs: Nfp_Seo_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luncurkan etalase yang patuh pajak dan terverifikasi serta hub komunitas pribadi untuk Gereja, Badan Amal, atau Organisasi Non-Profit Anda. Nol coding diperlukan.`)
};

/** @type {(inputs: Nfp_Seo_DescInputs) => LocalizedString} */
const ja_nfp_seo_desc = en_nfp_seo_desc;

/** @type {(inputs: Nfp_Seo_DescInputs) => LocalizedString} */
const zh_nfp_seo_desc = en_nfp_seo_desc;

/** @type {(inputs: Nfp_Seo_DescInputs) => LocalizedString} */
const ar_nfp_seo_desc = en_nfp_seo_desc;

/** @type {(inputs: Nfp_Seo_DescInputs) => LocalizedString} */
const it_nfp_seo_desc = en_nfp_seo_desc;

/** @type {(inputs: Nfp_Seo_DescInputs) => LocalizedString} */
const ru_nfp_seo_desc = en_nfp_seo_desc;

/** @type {(inputs: Nfp_Seo_DescInputs) => LocalizedString} */
const pt_nfp_seo_desc = en_nfp_seo_desc;

/** @type {(inputs: Nfp_Seo_DescInputs) => LocalizedString} */
const ko_nfp_seo_desc = en_nfp_seo_desc;

/**
* | output |
* | --- |
* | "Launch a verified, tax-compliant storefront and private community hub for your Church, Charity, or NFP. Zero coding required." |
*
* @param {Nfp_Seo_DescInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const nfp_seo_desc = /** @type {((inputs?: Nfp_Seo_DescInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nfp_Seo_DescInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nfp_seo_desc(inputs)
	if (locale === "es") return es_nfp_seo_desc(inputs)
	if (locale === "fr") return fr_nfp_seo_desc(inputs)
	if (locale === "de") return de_nfp_seo_desc(inputs)
	if (locale === "ja") return ja_nfp_seo_desc(inputs)
	if (locale === "zh") return zh_nfp_seo_desc(inputs)
	if (locale === "ar") return ar_nfp_seo_desc(inputs)
	if (locale === "id") return id_nfp_seo_desc(inputs)
	if (locale === "it") return it_nfp_seo_desc(inputs)
	if (locale === "ru") return ru_nfp_seo_desc(inputs)
	if (locale === "pt") return pt_nfp_seo_desc(inputs)
	return ko_nfp_seo_desc(inputs)
});